import { ActiveWorkflowsBySpace } from "./ActiveWorkflowsBySpace";
import { AutofixAutotunePanel } from "./AutofixAutotunePanel";
import { DuplicateWorkflowsPanel } from "./DuplicateWorkflowsPanel";
import { ExecutionVolumeBySpace } from "./ExecutionVolumeBySpace";
import { FailingWorkflowsPanel } from "./FailingWorkflowsPanel";
import { MonitoringLayout } from "./MonitoringLayout";
import { RouteAuthPanel } from "./RouteAuthPanel";
import { StorageBySpace } from "./StorageBySpace";
import { WorkflowDependenciesPanel } from "./WorkflowDependenciesPanel";
import { SideStack, SideStackPair, WorkflowsGrid } from "./workflowsLayout";

export function Workflows() {
  return (
    <MonitoringLayout>
      <WorkflowsGrid>
        <ActiveWorkflowsBySpace />
        <ExecutionVolumeBySpace />
        <StorageBySpace />
        <RouteAuthPanel />
        <SideStack>
          <FailingWorkflowsPanel />
          <DuplicateWorkflowsPanel />
          <SideStackPair>
            <AutofixAutotunePanel />
            <WorkflowDependenciesPanel />
          </SideStackPair>
        </SideStack>
      </WorkflowsGrid>
    </MonitoringLayout>
  );
}
